<template>
  <div
    v-if="!browerInfo.isMiniProgram && !browerInfo.isMallApp"
    ref="downloadWrap"
    class="download-wrap"
  >
    <img class="logo" :src="logoImg" />
    <div class="info">
      <span class="title">{{ APP_CONFIG.app_name }} App</span>
      <span class="desc"
        >批发买菜，上{{ APP_CONFIG.app_short_name }}，就是便宜</span
      >
    </div>

    <div class="btn open-btn" @click="openAppSchema">打开</div>
    <div class="btn download-btn" @click="onClickDownload">下载</div>
  </div>
</template>

<script>
import { openApp, downLoadApp } from '@/utils/app_download'
import { APP_CONFIG, logoImg } from '@/defines/environment/config'

export default {
  data() {
    return {
      browerInfo: window.matrix,
      APP_CONFIG,
      logoImg
    }
  },
  methods: {
    /**
     * 打开 App 或 跳到下载页
     */
    openAppSchema() {
      openApp({
        showWxBrowerPopup: true,
        openToast: () => {
          this.$toast({
            message:
              '您当前浏览器版本可能无法自动打开APP，若未正常打开，请尝试手动打开APP。',
            duration: '4000'
          })
        }
      })
    },
    onClickDownload() {
      downLoadApp()
    }
  }
}
</script>

<style lang="scss" scoped>
.download-wrap {
  display: flex;

  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 501;

  padding: 0.14rem 0.22rem;

  background-color: #ffffff;
  border-top: #f6f6f6 solid 1px;

  align-items: center;

  .logo {
    width: 0.68rem;
    height: 0.68rem;
  }

  .info {
    display: flex;

    width: 0;
    margin-left: 0.2rem;

    flex: 1;
    flex-direction: column;

    font-size: 0.24rem;

    .title {
      font-size: 0.28rem;
      font-weight: bold;
    }

    .desc {
      margin-top: 0.08rem;

      color: #666666;
    }
  }

  .btn {
    width: 1.12rem;
    height: 0.48rem;
    margin-left: 0.12rem;

    background-color: #15bb5c;
    border-radius: 0.4rem;

    font-size: 0.28rem;
    line-height: 0.5rem;
    text-align: center;
    color: #ffffff;
    &.open-btn {
      background-color: #f5f5f5;

      color: #15bb5c;
    }
  }
}
</style>
